import React, { FC } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { Button } from '../../../Form/Button/button.scomponent';
import { useNavigate } from 'react-router-dom';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface Props {
    handleClose: (state: any) => void;
}

const ModalSelectOrderChoices : FC<Props> = ({ handleClose }) => {
    const navigate = useNavigate()
  

  return (
  
     
      <Dialog
        open
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        fullWidth
        maxWidth="sm"
      >
        {/* <DialogTitle>Escolha uma opção</DialogTitle> */}
        <DialogContent sx={{ gap: '25px'}}>
           
        <Button onClick={() => navigate('/orders-single-form')} variant='outlined' >Pedido de Venda (Avulso)</Button>
        <Button onClick={() => navigate('/orders-replacement-form')} variant='contained' sx={{  marginTop: '25px'}}>Pedido de Reposição</Button>
        </DialogContent>
        
      </Dialog>
    
  );
}

export { ModalSelectOrderChoices }